import shop from '../../api/shop';
import * as types from '../mutation-types';

// initial state
const state = {
  all: [],
  hasProducts: false
};

// getters
const getters = {
  allProducts: state => state.all
};

// actions
const actions = {
  getAllProducts({ commit, state }) {
    if (!state.hasProducts) {
      state.hasProducts = true;

      shop
        .getProducts()
        .then(products => {
          commit(types.RECEIVE_PRODUCTS, { products });
        })
        .catch(() => {});
    }
  }
};

// mutations
const mutations = {
  [types.RECEIVE_PRODUCTS](state, { products }) {
    state.all = products;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
